/* ============================================================
   La Nuit — toast.js
   Site-wide toast notifications.
   Use: window.LaNuit.toast('Saved to wishlist', { variant: 'success' });
        window.LaNuit.toast('Removed', { variant: 'info', icon: 'heart-off' });
   variants: success | info | warn | error
   ============================================================ */
(function () {
  let container = null;

  function ensureContainer() {
    if (container && document.body.contains(container)) return container;
    container = document.createElement('div');
    container.className = 'toast-stack';
    container.setAttribute('aria-live', 'polite');
    container.setAttribute('aria-atomic', 'false');
    document.body.appendChild(container);
    return container;
  }

  function show(message, opts) {
    opts = opts || {};
    const stack = ensureContainer();
    const variant = opts.variant || 'info';
    const duration = opts.duration || 2800;

    /* Colours are applied INLINE (not via the stylesheet) so they can never
       be defeated by CSS load order, a cached toast.css, or custom-property
       scoping. Inline styles win the cascade. Hard-coded brand hex — the
       message is never white. */
    const PALETTE = {
      success: { bg: '#FAF6F2', fg: '#8E3D55', bd: 'rgba(179,80,106,0.30)' },
      info:    { bg: '#FAF6F2', fg: '#8E3D55', bd: 'rgba(179,80,106,0.30)' },
      warn:    { bg: '#FAF6F2', fg: '#8A6A1F', bd: 'rgba(200,164,90,0.45)' },
      error:   { bg: '#FAF6F2', fg: '#A23B3B', bd: 'rgba(162,59,59,0.40)' }
    };
    const pal = PALETTE[variant] || PALETTE.info;

    const t = document.createElement('div');
    t.className = `toast toast--${variant}`;
    t.setAttribute('role', variant === 'error' || variant === 'warn' ? 'alert' : 'status');
    t.style.setProperty('background', pal.bg, 'important');
    t.style.setProperty('color', pal.fg, 'important');
    t.style.setProperty('border', '1px solid ' + pal.bd, 'important');
    t.style.setProperty('-webkit-backdrop-filter', 'none', 'important');
    t.style.setProperty('backdrop-filter', 'none', 'important');

    if (opts.iconHTML) {
      const ic = document.createElement('span');
      ic.className = 'toast__icon';
      ic.innerHTML = opts.iconHTML;
      ic.style.setProperty('color', pal.fg, 'important');
      t.appendChild(ic);
    }
    const msg = document.createElement('span');
    msg.className = 'toast__msg';
    msg.textContent = message;
    msg.style.setProperty('color', pal.fg, 'important');
    t.appendChild(msg);

    if (opts.actionLabel && typeof opts.onAction === 'function') {
      const a = document.createElement('button');
      a.type = 'button';
      a.className = 'toast__action';
      a.textContent = opts.actionLabel;
      a.style.setProperty('color', pal.fg, 'important');
      a.addEventListener('click', () => { opts.onAction(); dismiss(t); });
      t.appendChild(a);
    }

    const close = document.createElement('button');
    close.type = 'button';
    close.className = 'toast__close';
    close.setAttribute('aria-label', 'Dismiss');
    close.style.setProperty('color', pal.fg, 'important');
    close.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg>';
    close.addEventListener('click', () => dismiss(t));
    t.appendChild(close);

    stack.appendChild(t);
    requestAnimationFrame(() => t.classList.add('is-visible'));

    const timer = setTimeout(() => dismiss(t), duration);
    t._timer = timer;
  }

  function dismiss(t) {
    if (t._timer) clearTimeout(t._timer);
    t.classList.remove('is-visible');
    t.classList.add('is-leaving');
    setTimeout(() => t.remove(), 240);
  }

  window.LaNuit = window.LaNuit || {};
  window.LaNuit.toast = show;
})();
